import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ChatEngine, KAIResponseType, LocalStorageKeys} from "../../types";
import {readLocalStorageValue} from "@mantine/hooks";

type State = {
    chosenResponseType: KAIResponseType;
    chosenChatEngine: ChatEngine;
};

const initialState: State = {
    chosenResponseType: KAIResponseType.Fast,
    chosenChatEngine: ChatEngine.Standard,
};

const getResponseTypeFromLocalStorage = () => {
    const localStorageValue = readLocalStorageValue({
        key: LocalStorageKeys.ResponseType,
        defaultValue: KAIResponseType.Fast,
    });
    return localStorageValue;
};

const getChatEngineFromLocalStorage = () => {
    const localStorageValue = readLocalStorageValue({
        key: LocalStorageKeys.ChatEngine,
        defaultValue: ChatEngine.Standard,
    });
    return localStorageValue;
};

const sessionSlice = createSlice({
    name: "session",
    initialState,
    reducers: {
        setChosenResponseType(state, action: PayloadAction<KAIResponseType>) {
            state.chosenResponseType = action.payload;
        },
        initializeResponseTypeFromLocalStorage(state) {
            state.chosenResponseType = getResponseTypeFromLocalStorage();
        },
        setChatEngine(state, action: PayloadAction<ChatEngine>) {
            state.chosenChatEngine = action.payload;
        },
        initializeChatEngineFromLocalStorage(state) {
            state.chosenChatEngine = getChatEngineFromLocalStorage();
        },
    },
});

export const {
    setChosenResponseType,
    initializeResponseTypeFromLocalStorage,
    setChatEngine,
    initializeChatEngineFromLocalStorage,
} = sessionSlice.actions;
export default sessionSlice.reducer;
